export enum TabKey {
    Wallets = 'wallets',
    Transactions = 'transactions',
    Members = 'members',
}
